import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { ApiVisa } from '../shared/api-visa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel, BasicApiResponseModel } from '../shared/api-response.model';
import { TinValidationDto } from '../../data-transfer-objects';


@Injectable({
  providedIn: 'root'
})

export class LHDNIntegrationService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "lhdn-integrations"

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "lhdn-integrations"
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.E_INVOICE_PREFIX + "lhdn-integrations"
    this.httpClient = http;
  }

  tinValidation(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + '/tin-validation/backoffice-ep'
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  tinValidationLoginEp(dtoObject: TinValidationDto, visa: ApiVisa): Observable<BasicApiResponseModel<TinValidationDto>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + '/tin-validation/login-ep'
    }
    return this.httpClient.post<BasicApiResponseModel<TinValidationDto>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  submissionDocDetails(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + '/submission-document-details/backoffice-ep'
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  tinValidationWithEntityAccessKey(dtoObject: TinValidationDto, entity_hdr_guid: string, access_key: string, visa: ApiVisa): Observable<BasicApiResponseModel<TinValidationDto>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      let apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = apiUrl + '/tin-validation/'+ entity_hdr_guid + "/" + access_key;
    }
    return this.httpClient.post<BasicApiResponseModel<TinValidationDto>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  //taxpayerName,idType,idValue,fileType,envType
  tinSearch(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + '/tin-search/backoffice-ep'
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
